import ListClientsView from "./view/list-clients-view";

export default ListClientsView;